import type { GroupPublic } from '@repo/types/groups';
import type { UserPublic } from '@repo/types/users';

import GroupSecondaryCard from '@/components/features/groups/GroupSecondaryCard';
import UserCard from '@/components/features/user/UserCard';
import { Separator } from '@/components/ui/separator';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface MeetingMembersProps {
  groups: GroupPublic[];
  users: UserPublic[];
}

export default function MeetingMembers(meetingMembersProps: MeetingMembersProps) {
  const { groups, users } = meetingMembersProps;

  return (
    <div className={'flex h-full w-full grow flex-col overflow-auto'}>
      <header className={'flex items-center justify-between gap-2 p-4'}>
        <div className={'flex h-10 items-center'}>
          <h3 className={'w-full truncate text-lg font-semibold'}>Goście spotkania</h3>
        </div>
      </header>
      <Separator />
      <Tabs defaultValue={'users'} className={'flex w-full grow flex-col overflow-auto'}>
        <div className={'p-4'}>
          <TabsList className={'grid w-full grid-cols-2'}>
            <TabsTrigger value={'users'}>Użytkownicy</TabsTrigger>
            <TabsTrigger value={'groups'}>Grupy</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value={'users'} className={'h-full px-4 pb-4'}>
          <div className={'flex flex-col gap-6 p-4'}>
            <div className={'space-y-2'}>
              <p className={'text-muted-foreground text-sm'}>Prowadzący</p>
              <div className={'flex-1 overflow-y-auto'}>
                {users
                  .filter((user) => user.lvl > 0)
                  .map((user) => (
                    <UserCard key={user.id} user={user} />
                  ))}
              </div>
            </div>
            <div className={'space-y-2'}>
              <p className={'text-muted-foreground text-sm'}>Uczestnicy</p>
              <div className={'flex-1 overflow-y-auto'}>
                {users
                  .filter((user) => user.lvl <= 0)
                  .map((user) => (
                    <UserCard key={user.id} user={user} />
                  ))}
              </div>
            </div>
          </div>
          {users.length === 0 && <p className={'text-muted-foreground text-center text-sm'}>Brak użytknowników</p>}
        </TabsContent>
        <TabsContent value={'groups'} className={'h-full px-4 pb-4'}>
          {groups.map((group) => (
            <GroupSecondaryCard key={group.id} group={group} />
          ))}
          {groups.length === 0 && <p className={'text-muted-foreground text-center text-sm'}>Brak grup</p>}
        </TabsContent>
      </Tabs>
    </div>
  );
}
